export { default } from './GoogleMap';
